// extracted by mini-css-extract-plugin
module.exports = {"container":"About_container__3bN0l","about":"About_about__6o7y3","aboutContent":"About_aboutContent__gcp1l","content":"About_content__3EmYl","links":"About_links__2Lvv3"};